import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(({ spacing, palette }) => ({
  paper: {
    padding: spacing(3),
    border: `1px solid ${palette.separator.main}`,
    borderRadius: spacing(1),
    backgroundColor: palette.otherElementsBackground.main,
    color: `${palette.contrastText.main} !important`,
  },
  productsBlock: {
    border: "1px solid transparent",
    borderRadius: spacing(1),
    padding: spacing(1.5),
  },
  title: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  quantity: {
    fontSize: 12,
    color: grey[600],
  },
  list: {
    "& div:last-child": {
      marginBottom: 0,
    },
  },
  productName: {
    fontSize: 14,
    lineHeight: "150%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginRight: spacing(1),
    color: `${palette.contrastText.main} !important`,
  },
  countOfItems: {
    fontSize: 12,
    lineHeight: "150%",
    color: `${palette.defaultSideText.main} !important`,
  },
  approvalRequired: {
    "& *": {
      color: grey[500],
    },
  },
  approvalNotRequired: {
    "& *": {
      color: "black",
    },
  },
  contrastText: {
    color: palette.contrastText.main,
  },
  approvalRequiredAlert: {
    fontSize: 12,
    lineHeight: "150%",
    color: palette.contrastText.main,
    padding: spacing(0.8, 1),
    backgroundColor: palette.alertWarning.main,
    borderRadius: "8px",
  },
  highlightedText: {
    color: palette.primary.main,
  },
}));
